(() => {
  if (customElements.get('mr-play-library')) return;
  class PlayLibrary extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controls = new AbortController();
      this.saved = new Set();
      try { const values = JSON.parse(localStorage.getItem('mr-playroom-saved') || '[]'); if (Array.isArray(values)) this.saved = new Set(values.filter(x => typeof x === 'string')); } catch {}
      try { this.labels = JSON.parse(this.querySelector('[data-mr-translations]').textContent); } catch { this.labels = {}; }
      this.mode = 'play'; this.goal = ''; this.set = ''; this.query = ''; this.quick = false; this.savedOnly = false;
      this.addEventListener('click', event => this.click(event), {signal: this.controls.signal});
      this.addEventListener('input', event => { if (event.target.matches('[data-mr-search]')) { this.query = event.target.value.trim().toLowerCase(); this.update(); } }, {signal: this.controls.signal});
      this.addEventListener('change', event => { if (event.target.matches('[data-mr-set]')) { this.set = event.target.value; this.update(); } }, {signal: this.controls.signal});
      this.drawGoals(); this.update(); this.loadAll();
    }
    disconnectedCallback() { this.controls?.abort(); this.initialized = false; }
    click(event) {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-mr-mode')) { this.mode = button.dataset.mrMode; this.goal = ''; this.drawGoals(); }
      else if (button.hasAttribute('data-mr-goal')) this.goal = button.dataset.mrGoal;
      else if (button.hasAttribute('data-mr-saved')) this.savedOnly = !this.savedOnly;
      else if (button.hasAttribute('data-mr-quick')) this.quick = !this.quick;
      else if (button.hasAttribute('data-mr-reset')) {
        this.goal = ''; this.set = ''; this.query = ''; this.quick = false; this.savedOnly = false;
        const search = this.querySelector('[data-mr-search]'); if (search) search.value = '';
        const select = this.querySelector('[data-mr-set]'); if (select) select.value = '';
      } else if (button.hasAttribute('data-mr-save')) {
        const key = button.closest('[data-mr-card]').dataset.key;
        if (this.saved.has(key)) this.saved.delete(key); else this.saved.add(key);
        try { localStorage.setItem('mr-playroom-saved', JSON.stringify([...this.saved])); } catch {}
      }
      this.update();
    }
    tagsFor(card) {
      let tags = []; try { tags = JSON.parse(card.dataset.tags); } catch {}
      const normalized = tags.map(t => t.toLowerCase().replace(/[^a-z0-9]/g, ''));
      const rules = {
        'play:Light & colour':['lightexploration','lightplay','colorexploration','shadowplay'],
        'play:Build & balance':['buildingactivity','balanceactivity'],
        'play:Small worlds':['smallworldplay','imaginativeplay'],
        'play:Quiet play':['independentplay'],
        'goal:Early maths':['earlymath','mathplay','geometry','unitblocks','shaperecognition'],
        'goal:Language':['languagedevelopment','earlyliteracy','phonics','letterrecognition'],
        'goal:Problem solving':['problemsolving'],
        'goal:Fine motor':['finemotor','handeyecoordination','finemotordevelopment'],
        'set:Acrylic blocks':['lucite','lucitecubes'],
        'set:Any building set':['woodenblocks','buildingactivity'],
        'set:James':['james','jamesblocks'], 'set:Riley':['riley','rileyblocks'],
        'set:Ines':['ines','inesblocks','lucitecubes'], 'set:Millie':['millie','millieblocks'],
        'set:Noa':['noa','noablocks'], 'set:Barca':['barca'], 'set:Bergen':['bergen'],
        'set:Alphabet Puzzles':['alphabetpuzzle','alphabetlearning']
      };
      for (const [tag, aliases] of Object.entries(rules)) if (aliases.some(a => normalized.includes(a))) tags.push(tag);
      return tags;
    }
    drawGoals() {
      const holder = this.querySelector('[data-mr-goals]'); if (!holder) return;
      const goals = this.mode === 'play' ? ['Light & colour', 'Build & balance', 'Small worlds', 'Quiet play'] : ['Early maths', 'Language', 'Problem solving', 'Fine motor'];
      holder.replaceChildren(...['', ...goals].map(goal => {
        const button = document.createElement('button'); button.type = 'button'; button.dataset.mrGoal = goal; button.textContent = goal ? (this.labels[this.mode]?.[goal] || goal) : (this.labels.all || 'All ideas'); return button;
      }));
    }
    update() {
      let visible = 0;
      const cards = [...this.querySelectorAll('[data-mr-card]')];
      cards.forEach(card => {
        const tags = this.tagsFor(card);
        const searchable = (card.dataset.search + ' ' + tags.join(' ')).toLowerCase();
        const minutes = Number(tags.find(t => t.startsWith('minutes:'))?.split(':')[1] || 0);
        const match = (!this.goal || tags.includes(this.mode + ':' + this.goal)) && (!this.set || tags.includes('set:' + this.set)) && (!this.quick || (minutes > 0 && minutes <= 5)) && (!this.savedOnly || this.saved.has(card.dataset.key)) && (!this.query || searchable.includes(this.query));
        card.hidden = !match; if (match) visible++;
        const saved = this.saved.has(card.dataset.key); const save = card.querySelector('[data-mr-save]');
        save.setAttribute('aria-pressed', String(saved)); save.classList.toggle('is-saved', saved);
        save.setAttribute('aria-label', ((saved ? this.labels.unsave : this.labels.save) || (saved ? 'Unsave' : 'Save')) + ' ' + card.querySelector('.mr-card-title').textContent.replace('↗','').trim());
        save.firstElementChild.textContent = saved ? '♥' : '♡';
      });
      this.querySelectorAll('[data-mr-mode]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mrMode === this.mode)));
      this.querySelectorAll('[data-mr-goal]').forEach(b => { const active = b.dataset.mrGoal === this.goal; b.setAttribute('aria-pressed', String(active)); b.classList.toggle('active', active); });
      const saved = this.querySelector('[data-mr-saved]'); saved.setAttribute('aria-pressed', String(this.savedOnly)); saved.classList.toggle('active', this.savedOnly);
      const quick = this.querySelector('[data-mr-quick]'); if (quick) { quick.setAttribute('aria-pressed', String(this.quick)); quick.classList.toggle('active', this.quick); }
      this.querySelector('[data-mr-empty]').hidden = visible > 0;
      const resultKey = (this.dataset.journal === 'true' ? 'stories_' : 'results_') + (visible === 1 ? 'one' : 'many');
      this.querySelector('[data-mr-results]').textContent = (this.labels[resultKey] || '__COUNT__ ideas to make your own').replace('__COUNT__', String(visible));
      const filtered = !!(this.goal || this.set || this.query || this.quick || this.savedOnly);
      const reset = this.querySelector('.results-line [data-mr-reset]'); reset.hidden = !filtered;
    }
    async loadAll() {
      const nav = this.querySelector('[data-mr-pagination]');
      if (!nav) return;
      const initialNext = nav.querySelector('[data-mr-next]');
      const currentPage = new URL(location.href).searchParams.get('page');
      let next = currentPage && currentPage !== '1' ? nav.dataset.mrFirst : initialNext?.href;
      if (!next) { nav.hidden = true; return; }
      const seenUrls = new Set(); const seenCards = new Set([...this.querySelectorAll('[data-mr-card]')].map(c => c.dataset.key));
      try {
        let pageCount = 0;
        while (next && pageCount++ < 40) {
          const url = new URL(next, location.href);
          if (url.origin !== location.origin || seenUrls.has(url.href)) throw new Error('Unexpected pagination');
          seenUrls.add(url.href);
          const response = await fetch(url, {credentials:'same-origin', signal:this.controls.signal});
          if (!response.ok) throw new Error('Could not load more articles');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const library = page.querySelector('mr-play-library'); if (!library) throw new Error('Missing article library');
          library.querySelectorAll('[data-mr-card]').forEach(card => { if (!seenCards.has(card.dataset.key)) { this.querySelector('[data-mr-grid]').append(document.importNode(card, true)); seenCards.add(card.dataset.key); } });
          next = library.querySelector('[data-mr-next]')?.getAttribute('href'); this.update();
        }
        if (next) throw new Error('More pages available');
        nav.hidden = true;
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.querySelector('[data-mr-load-note]').hidden = false;
      }
    }
  }
  customElements.define('mr-play-library', PlayLibrary);
})();
